import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RequestApproval from 'components/simulation/types/lmnp/RequestApproval';
import Overview from 'components/simulation/types/lmnp/Overview';
import Property from 'components/simulation/types/lmnp/Property';
import Funding from 'components/simulation/types/lmnp/Funding';
import Charges from 'components/simulation/types/lmnp/Charges';
import ResponseApproval from 'components/simulation/types/lmnp/ResponseApproval';
import Details from 'components/simulation/types/lmnp/Details';
import { SummaryForm, SummaryPage } from 'components/simulation/types/lmnp/Summary';

const Lmnp = () => (
    <Routes>
        <Route path="/resume" element={<Overview />} />
        <Route path="/bien" element={<Property />} />
        <Route path="/financement" element={<Funding />} />
        <Route path="/charges" element={<Charges />} />
        <Route path="/simulation" element={<Details />} />
        <Route path="/summary" element={<SummaryPage />} />
        <Route path="/summary/form" element={<SummaryForm />} />
        <Route path="/approval/request" element={<RequestApproval />} />
        <Route path="/approval/:approval" element={<ResponseApproval />} />
    </Routes>
);

export default Lmnp;
